import { EnhancedModel } from './enhanced.model';
import { Location } from './location.model';
import { User } from './user.model';
import { Service } from './service.model';
import { JsonInterface } from './json.interface';

export class Appointment extends EnhancedModel implements JsonInterface {

    public static get TYPE_CREATE():string {
        return 'create';
    }
    public static get TYPE_UPDATE():string {
        return 'update';
    }
    public static get TYPE_DELETE():string {
        return 'delete';
    }

    private _id:number = 0;
    public get id():number {
        return this._id;
    }
    public set id(value:number) {
        this._id = value;
    }

    private _location:Location = new Location();
    public get location():Location {
        return this._location;
    }
    public set location(value:Location) {
        this._location = value;
    }

    private _notes:string = '';
    public get notes():string {
        return this._notes;
    }
    public set notes(value:string) {
        this._notes = value;
    }

    private _slots:number = 0;
    public get slots():number {
        return this._slots;
    }
    public set slots(value:number) {
        this._slots = value;
    }

    /**
     * string formatted time "10:30"
     */
    private _startTime:string = '';
    public get startTime():string {
        return this._startTime;
    }
    public set startTime(value:string) {
        this._startTime = value;
        let time = this._startTime.split(':');
        if (time.length === 2) {
            this._appointmentDate.setHours(Number(time[0]), Number(time[1]));
        }
    }

    /**
     * Partial ISO formatt date "2017-06-01"
     */
    private _startDate: string = '';
    public get startDate(): string {
        return this._startDate;
    } public set startDate(value: string) {
        this._startDate = value;
        let date = this._startDate.split('-');
        if (date.length === 3) {
            this._appointmentDate.setFullYear(Number(date[0]));
            this._appointmentDate.setMonth(Number(date[1]) - 1);
            this._appointmentDate.setDate(Number(date[2]));
        }
    }

    private _user:User = new User;
    public get user():User {
        return this._user;
    }
    public set user(value:User) {
        this._user = value;
    }

    private _service: Service = new Service();
    public get service(): Service {
        return this._service;
    } public set service(value: Service) {
        this._service = value;
    }

    private _applicationCode: string = '';
    public get applicationCode(): string {
        return this._applicationCode;
    } public set applicationCode(value: string) {
        this._applicationCode = value;
    }

    private _appointmentDate: Date = new Date();
    public get appointmentDate(): Date {
        return this._appointmentDate;
    } public set appointmentDate(value: Date) {
        this._appointmentDate = value;
        this._startTimestamp = value.toISOString();
        this._startDate = value.getFullYear() + '-' + value.getMonth() + '-' + value.getDate();
        this._startTime = value.getUTCHours() + ':' + value.getUTCMinutes();
    }

    private _startTimestamp:string = '';
    public get startTimestamp():string {
        return this._startTimestamp;
    } public set startTimestamp(value:string) {
        this._startTimestamp = value;
    }

    private _endTimestamp:string = '';
    public get endTimestamp():string {
        return this._endTimestamp;
    } public set endTimestamp(value:string) {
        this._endTimestamp = value;
    }

    private _duration:number = 0;
    public get duration():number {
        return this._duration;
    } public set duration(value:number) {
        this._duration = value;
    }

    private _updateDate: Date = null;
    public get updateDate(): Date {
        return this._updateDate;
    } 

    constructor(obj: any = null) {
        super();
        if (obj !== null) {
            if (obj instanceof Appointment) {
                this.mapClone(obj);
            } else {
                this.mapJson(obj);
            }
        }
    }

    /*
        {
            "applicationCode": "665",
            "duration": 15,
            "endTimestamp": "2017-04-03T09:15:00",
            "eventTypeId": 1,
            "locationId": 1,
            "serviceId": 1,
            "startTimestamp": "2017-04-03T09:00:00",
            "userId": 1
        }
    */

    public toJSON():any {
        let json:any = {};
        json.applicationCode = this.applicationCode; // "string"
        json.eventTypeId = 1; // this.eventTypeId; // 1
        json.locationId = this.location.id; 
        json.serviceId = this.service.id;
        json.startTimestamp = this.startTimestamp;  
        json.duration = this.duration;
        json.endTimestamp = this.endTimestamp; 
        json.userId = 1; // 1 // TODO: not sure what to do about this yet
        return json;
    }

    public clone() {
        let cloned = new Appointment(this);
        return cloned;
    }

    protected mapClone(obj: Appointment) {
        this.id = obj.id;
        this.applicationCode = obj.applicationCode;
        this.location = obj.location;
        this.notes = obj.notes;
        this.slots = obj.slots;
        this.startTime = obj.startTime;
        this.startDate = obj.startDate;
        this.startTimestamp = obj.startTimestamp;
        this.duration = obj.duration;
        this.endTimestamp = obj.endTimestamp;
        this.user = obj.user;
        this._updateDate = obj.updateDate;
    }

    protected mapJson(obj: any) {
        if (obj.hasOwnProperty('id')) {
            this.id = obj.id;
        }
        if (obj.hasOwnProperty('location')) {
            this.location = new Location(obj.location);
        }
        if (obj.hasOwnProperty('notes')) {
            this.notes = obj.notes;
        }
        if (obj.hasOwnProperty('slots')) {
            this.slots = obj.slots;
        }
        if (obj.hasOwnProperty('startTime')) {
            this.startTime = obj.startTime;
        }
        if (obj.hasOwnProperty('user')) {
            this.user = new User(obj.user);
        }
        if (obj.hasOwnProperty('startDate')) {
            this.startDate = obj.startDate;
        }
        if (obj.hasOwnProperty('startTimestamp')) {
            this.startTimestamp = obj.startTimestamp;
        }
        if (obj.hasOwnProperty('endTimestamp')) {
            this.endTimestamp = obj.endTimestamp;
        }
        if (obj.hasOwnProperty('applicationCode')) {
            this.applicationCode = obj.applicationCode;
        }
        if (obj.hasOwnProperty('duration')) {
            this.duration = obj.duration;
        }
        if (obj.hasOwnProperty('lastUpdatedDate')) {
            if (Date.parse(obj.lastUpdatedDate)) {
                this._updateDate = new Date(obj.lastUpdatedDate);
            }
        }
    }

}
